import axios from 'axios';
import JwtService from '@/core/services/JwtService.ts';
import router from '@/router/index.ts';
import store from '@/store/index.ts'
import { ElNotification } from 'element-plus';


const appAxios = axios.create({
    baseURL: process.env.NODE_ENV === "production" ? "https://api.theauditer.com/api" : "https://test.theauditer.com/api",
    headers: {
        Authorization: JwtService.getToken() ? ` Bearer  ${JwtService.getToken()}` : ""
    },
})
appAxios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
appAxios.interceptors.response.use(response => {

    if (!response.data.Success) {
        setTimeout(() => {
            ElNotification({
                title: "",
                message: response.data.Message,
                type: 'warning',
                iconClass: 'text-warning',
                position: 'top-right',
                zIndex: 20000,
                duration: 3200,
                customClass: "notification-app-vue"
            })
        }, 500)
    } else if (response.config.url.toLowerCase().indexOf('get') === -1 && response.config.method === 'post') {
        setTimeout(() => {
            ElNotification({
                title: "",
                message: response.data.Message,
                type: 'success',
                iconClass: 'text-success',
                position: 'top-right',
                zIndex: 20000,
                duration: 3200,
                customClass: "notification-app-vue"
            })
        }, 500)
    }

    return response

}, error => {

    if (error.response.status === 401) {
        store.commit("AuthModule/LOG_OUT")
        router.push({ name: "sign-in" });
    }
    else if (error.response.status === 403) {
        // router.push({ name: "dashboard" });

    }
    else {
        if (error.response) {
            if (error.response.data.errors == undefined) {
                setTimeout(() => {
                    ElNotification({
                        title: "",
                        message: error.response.data.Message,
                        type: 'error',
                        position: 'top-right',
                        zIndex: 20000,
                        duration: 3200,
                        customClass: "notification-app-vue",
                        iconClass: 'text-danger',
                    })
                }, 500)
            }
            else {
                Object.keys(error.response.data.errors).forEach(item => {

                    setTimeout(() => {
                        ElNotification({
                            title: error.response.data.title,
                            message: error.response.data.errors[item][0],
                            type: 'error',
                            position: 'top-right',
                            zIndex: 20000,
                            duration: 3200,
                            customClass: "notification-app-vue",
                            iconClass: 'text-danger',
                        })
                    }, 500)
                })
            }
        }
    }
})


export default appAxios